export function complexVtrUpgradeAudit(complexId) {
  return {
    path: `complexes/${complexId}/vlan_upgrade_audit`,
    accept: 'text/json',
  };
}
export function switchConfig({
  name, units, maxLimitSpeed, vlanRangeStart, vlanRangeEnd,
}) {
  return {
    path: 'networking/switch_config',
    method: 'POST',
    body: JSON.stringify({
      name,
      units,
      max_limit_speed: maxLimitSpeed,
      vlan_range_start: vlanRangeStart,
      vlan_range_end: vlanRangeEnd,
    }),
  };
}

export function setUnitQueue(unitId) {
  return {
    method: 'POST',
    path: 'queue/unit',
    body: JSON.stringify({ unit_id: unitId }),
  };
}

export function vtrAudit(search) {
  return {
    path: `queue/check${search}`,
    skipBodyCheck: true,
  };
}

export const networkingViewCheck = {
  path: '/api/v1/networking',
  method: 'GET',
};

export const vtrQueueCheck = {
  path: '/api/v1/queue',
  method: 'GET',
};
